import swiper from './swiper'

export default {
    bindMain(selector) {
        swiper(selector, {
            breakpoints: null,
            spaceBetween: 0,
            pagination: {
                type: 'fraction'
            }
        })
    },

    bindMini(container = document) {
        container.querySelectorAll('.swiper--mini:not(.swiper-initialized)').forEach(el => {
            swiper(el, {
                pagination: { type: null },
                breakpoints: {
                    768: { slidesPerView: 2 },
                    1200: { slidesPerView: 3 }
                }
            })
        })
    },

    bindSingle(container = document) {
        container.querySelectorAll('.swiper--single:not(.swiper-initialized)').forEach(el => {
            swiper(el, {
                breakpoints: null,
                autoHeight: true,
                pagination: { type: null }
            })
        })
    }
}
